export default "import './Main';\r\n"